import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { BarChart3 } from "lucide-react";

// Separate, unbundled analytics consent (DPDP). App works fully if declined.
export default function ConsentBanner() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || user === false) return;
    api.get("/me/consent").then((r) => { if (!r.data.asked) setShow(true); }).catch(() => {});
  }, [user]);

  const decide = async (consent) => {
    setShow(false);
    try { await api.post("/consent", { consent }); } catch {}
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-20 lg:bottom-4 inset-x-3 lg:inset-x-auto lg:right-4 lg:w-[380px] z-[10002] bg-white rounded-2xl border shadow-xl p-4" data-testid="consent-banner">
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><BarChart3 className="h-5 w-5 text-primary" /></span>
        <div className="flex-1">
          <p className="font-bold text-[15px]">Help improve Agro Madat?</p>
          <p className="text-xs text-muted-foreground mt-1">Allow anonymous usage analytics so we can make the app better. This is separate from using the app — everything works either way.</p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" variant="outline" className="rounded-xl flex-1" onClick={() => decide(false)} data-testid="consent-decline">No thanks</Button>
            <Button size="sm" className="rounded-xl flex-1" onClick={() => decide(true)} data-testid="consent-allow">Allow</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
